//REEMPLAZO PARA SOLCICITUDES
import { Cliente } from "../objetos/objeto_cliente";
import { Configuracion } from "../objetos/objeto_configuracion";
import { ServicioAgendado } from "../objetos/objeto_servicio";
import { formatearFechaCompleta , formatearPrecio} from "./utils";

/**
 * Función para procesar y reemplazar variables en mensajes de solicitud
 * @param {Solicitud} solicitud - Objeto solicitud con los datos
 * @param {Object} configuracion - Objeto de configuración con los mensajes
 * @returns {string} - Mensaje procesado con variables reemplazadas
 */
export const procesarMensajeSolicitud = (solicitud, configuracion) => {
  console.log("🔍 INICIO - procesando solicitud");
  console.log("📋 Solicitud recibida:", solicitud);
  console.log("⚙️ Configuración recibida:", configuracion);
  const nombreEmpresaParaURL = (solicitud.nombreEmpresa || '').replace(/ /g, '%20');

  if(!solicitud || !configuracion){
    console.error("❌ Error: Solicitud o configuración no válida");
    console.log("solicitud:", solicitud);
    console.log("configuracion:", configuracion);
    return "Error: Solicitud o configuración no válida";
  }

  console.log("🎯 Tipo de servicio:", solicitud.Servicio);
  
  let mensajeBase = '';

  switch(solicitud.Servicio){
    case 'PARCIAL':
    case 'QUIZ':
      mensajeBase = configuracion.plantillaSolicitudExamen;
      console.log("📝 Usando plantilla de EXAMEN");
      break;

    case 'TALLER':
      mensajeBase = configuracion.plantillaSolicitudTaller;
      console.log("📝 Usando plantilla de TALLER");
      break;
              
    case 'TESIS':
      mensajeBase = configuracion.plantillaSolicitudTesis;
      console.log("📝 Usando plantilla de TESIS");
      break;

    case 'CLASES PERSONALIZADAS':
      mensajeBase = configuracion.plantillaSolicitudAsesoria;
      console.log("📝 Usando plantilla de ASESORÍA");
      break;

    default:
      mensajeBase = configuracion.SOLICITUD;
      console.log("📝 Usando plantilla GENERAL (default)");
      break;
  }

  console.log("📄 Mensaje base seleccionado:");
  console.log(mensajeBase);
  
  if (!mensajeBase) {
    console.warn("⚠️ ADVERTENCIA: No se encontró mensaje base, usando fallback");
    mensajeBase = configuracion.SOLICITUD || "No hay mensaje configurado";
  }

  // Reemplazos - incluir TODAS las variantes posibles
  const reemplazos = {
    '/servicio/': solicitud.Servicio || '',
    '/idcotizacion/': solicitud.idcotizacion?.toString() || '',
    '/materia/': solicitud.materia || '',
    '/fechaentrega/': formatearFecha(solicitud.fechaentrega),
    '/horaentrega/': formatearHora(solicitud.fechaentrega),
    '/resumen/': solicitud.resumen || '',
    '/urlarchivos/': solicitud.archivos || '',
    '/nombreempresa/': nombreEmpresaParaURL || 'Error, notificar',
    '/nombreEmpresa/': solicitud.nombreEmpresa || 'Error, notificar',
    '/temasExamen/': solicitud.objetoFaltante.temasExamen || 'Temas no especificados',
    '/duracionExamen/': solicitud.objetoFaltante.duracionExamen || 'Duracion no especificada',
    '/formatoEntrega/' : solicitud.objetoFaltante.formatoEntrega || 'Formato de entrega no definido',
    '/urlarchivos/' :  `obsoleto, esta variable se va a borrar`,
    '/temaTesis/' : solicitud.objetoFaltante.temaTesis || 'Tema de tesis no definida',
    '/carreraTesis/' : solicitud.objetoFaltante.carrera || 'Carrera de tesis no definida',
    '/universidadTesis/' : solicitud.objetoFaltante.universidad || 'Universidad de tesis no definida',
    '/normasCitacionTesis/' : solicitud.objetoFaltante.normasCitacion || 'Normas de citacion de tesis no definida',
  };

  console.log("🔄 Reemplazos a realizar:");
  console.table(reemplazos);

  let mensajeProcesado = mensajeBase;

  // Reemplazar cada variable en el mensaje
  Object.entries(reemplazos).forEach(([variable, valor]) => {
    console.log(`🔍 Buscando variable: ${variable}`);
    console.log(`📝 Valor a reemplazar: "${valor}"`);
    
    // Contar cuántas veces aparece la variable
    const ocurrencias = (mensajeProcesado.match(new RegExp(variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')) || []).length;
    console.log(`📊 Ocurrencias encontradas: ${ocurrencias}`);
    
    if (ocurrencias > 0) {
      // Usar expresión regular global para reemplazar todas las ocurrencias
      const regex = new RegExp(variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
      const mensajeAntes = mensajeProcesado;
      mensajeProcesado = mensajeProcesado.replace(regex, valor);
      
      console.log(`✅ Reemplazo realizado para ${variable}`);
      console.log(`Antes: "${mensajeAntes.substring(0, 100)}..."`);
      console.log(`Después: "${mensajeProcesado.substring(0, 100)}..."`);
    } else {
      console.log(`⚠️ Variable ${variable} no encontrada en el mensaje`);
    }
  });
  
  // Convertir saltos de línea literales a saltos reales
  mensajeProcesado = mensajeProcesado.replace(/\\n/g, '\n');

  console.log("🎉 RESULTADO FINAL:");
  console.log("=" .repeat(50));
  console.log(mensajeProcesado);
  console.log("=" .repeat(50));

  return mensajeProcesado;
};

//REEMPLAZO PARA CONTABILIDAD
/**
 * Función para procesar y reemplazar variables en mensajes de solicitud
 * @param {ServicioAgendado} servicio - Objeto solicitud con los datos
 * @param {Configuracion} configuracion - Objeto de configuración con los mensajes
 * @param {Cliente} cliente - Objeto de configuración con los mensajes
 * @returns {string} - Mensaje procesado con variables reemplazadas
 */
export const procesarMensajeConfirmaacion = (servicio, configuracion,isTutor,cliente,isCliente = true) =>{
    const nombreEmpresaParaURL = (servicio.nombreEmpresa || '').replace(/ /g, '%20');

    if(!servicio || !configuracion){
      return "Error: Servicio o configuración no válida";
    }

    let mensajeBase = configuracion.CONFIRMACION_CLIENTE;

    //las confirmaciones debem ser las mismas
    if(!mensajeBase){
      console.warn("⚠️ ADVERTENCIA: No se encontró mensaje base, usando fallback");
      return 'No se encontro mensaje base';
    }

    // Si es cliente, remover la línea de URL antes de procesar
    if (isCliente) {
      // Buscar y eliminar la línea que contiene la URL de confirmación
      const lineas = mensajeBase.split('\n');
      const lineasFiltradas = lineas.filter(linea => 
        !linea.includes('✅URL confirmación:') && 
        !linea.includes('https://tutor.dufyasesorias.com/dashboard/detalles_servicio/')
      );
      mensajeBase = lineasFiltradas.join('\n');
    }

    const resultadoServicio = obtenerServicioPorIdentificador(servicio.identificadorcodigo);

    //reemplazos
    const reemplazos = {
    '/nombreempresa/': nombreEmpresaParaURL || 'Error',
    '/servicio/' : resultadoServicio.servicio,
    '/servicioplural/' : resultadoServicio.plural,
    '/materia/' : servicio.materia,
    '/nombreusuario/' : isTutor ? servicio.tutor : cliente.nombrecompletoCliente, //despues cambiar el nombre de tutor a su real
    '/rolusuario/' : isTutor ? 'Tutor' : 'Cliente',
    '/preciousuario/' : isTutor ? formatearPrecio(servicio.preciotutor) : formatearPrecio(servicio.preciocobrado),
    '/fecha de entrega/' : formatearFechaPorIdentificador(servicio.fechaentrega,servicio.identificadorcodigo),
    '/codigo/' : servicio.codigo,
    '/idsolicitud/' : servicio.idsolicitud,
  };

  let mensajeProcesado = mensajeBase;

    // Reemplazar cada variable en el mensaje
  Object.entries(reemplazos).forEach(([variable, valor]) => {

    const ocurrencias = (mensajeProcesado.match(new RegExp(variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')) || []).length;
    
    if (ocurrencias > 0) {
      const regex = new RegExp(variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
      const mensajeAntes = mensajeProcesado;
      mensajeProcesado = mensajeProcesado.replace(regex, valor);
      
    } else {

    }
  });

  //saltos reales
  mensajeProcesado = mensajeProcesado.replace(/\\n/g, '\n');
  return mensajeProcesado;
  
};

//FECHAS FORMATEADAS
 // Formatear fechas y horas
const formatearFecha = (fecha) => {
    if (!fecha) return "";
    const fechaObj = fecha instanceof Date ? fecha : new Date(fecha);
    return fechaObj.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

const formatearHora = (fecha) => {
    if (!fecha) return "";
    const fechaObj = fecha instanceof Date ? fecha : new Date(fecha);
    return fechaObj.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };


//formatear fecha según el identificador de codigo
const formatearFechaPorIdentificador = (fecha, identificador) => {
    if (!fecha) return '';
    
    // Asegurar que fecha sea un objeto Date
    const fechaObj = typeof fecha === 'string' ? new Date(fecha) : fecha;
    
    // Verificar si la fecha es válida
    if (isNaN(fechaObj.getTime())) return '';
    
    // Extraer día, mes y hora
    const dia = fechaObj.getDate().toString().padStart(2, '0');
    const mes = (fechaObj.getMonth() + 1).toString().padStart(2, '0');
    
    // Formatear hora en formato 12 horas con AM/PM
    let hora = fechaObj.getHours();
    const minutos = fechaObj.getMinutes().toString().padStart(2, '0');
    const ampm = hora >= 12 ? 'PM' : 'AM';
    
    // Convertir a formato 12 horas
    hora = hora % 12;
    hora = hora ? hora : 12; // Si es 0, mostrar 12
    const horaFormateada12 = hora.toString().padStart(2, '0');
    
    const fechaFormateada = `${dia}/${mes}`;
    const horaFormateada = `${horaFormateada12}:${minutos} ${ampm}`;
    
    if (!identificador) {
        return `${fechaFormateada} ${horaFormateada}`;
    }
    
    const idUpper = identificador.toUpperCase();
    
    switch (idUpper) {
        case 'P': // PARCIAL o QUIZ
            return `${fechaFormateada} ${horaFormateada}`;
        case 'T': // TALLER
            return `${fechaFormateada} ANTES DE ${horaFormateada}`;
        case 'A': // CLASES PERSONALIZADAS
            return `${fechaFormateada} ${horaFormateada}`;
        case 'TES': // TESIS
            return `${fechaFormateada} ${horaFormateada}`;
        default:
            return `${fechaFormateada} ${horaFormateada}`;
    }
}

//obtener servicio y plural por identificador de codigo
const obtenerServicioPorIdentificador = (identificador) => {
    if (!identificador) {
        return {
            servicio: 'NO-PROGRAMADO',
            plural: 'NO-PROGRAMADOS'
        };
    }
    
    const idUpper = identificador.toUpperCase();
    
    switch (idUpper) {
        case 'P':
            return {
                servicio: 'PARCIAL',
                plural: 'PARCIALES'
            };
        case 'Q':
            return {
                servicio: 'QUIZ',
                plural: 'QUICES'
            };
        case 'T':
            return {
                servicio: 'TALLER',
                plural: 'TALLERES'
            };
        case 'A':
            return {
                servicio: 'CLASES PERSONALIZADAS',
                plural: 'CLASES PERSONALIZADAS'
            };
        case 'TES':
            return {
                servicio: 'TESIS',
                plural: 'TESIS'
            };
        default:
            return {
                servicio: 'NO-PROGRAMADO',
                plural: 'NO-PROGRAMADOS'
            };
    }
}

